module.exports = __webpack_public_path__ + "views/new.4de4bea48a6918eb73b26a7ca1b95cd0.html";